const sharedMovilDetails = ['WhatsApp ilimitado', 'llamadas y sms ilimitados'];

export const boxProperties = [
    {
        category: '4play_movil',
        prices: [
            {
                vel: 80,
                promoVel: 120,
            },
            {
                vel: 100,
                promoVel: 150,
            },
            {
                vel: 150,
                promoVel: 200,
            },
            {
                vel: 200,
                promoVel: 500,
            },
            {
                vel: 500,
                promoVel: 1000,
            },
            {
                vel: 1000,
            },
        ],
    },
    {
        category: 'tripleplay',
        prices: [
            {
                vel: 80,
                promoVel: 100,
            },
            {
                vel: 100,
                promoVel: 150,
            },
            {
                vel: 150,
                promoVel: 200,
            },
            {
                vel: 200,
                promoVel: 500,
            },
            {
                vel: 500,
                promoVel: 1000,
            },
            {
                vel: 1000,
            },
        ],
    },
    {
        category: 'tripleplay_movil',
        prices: [
            {
                vel: 80,
                promoVel: 120,
            },
            {
                vel: 100,
                promoVel: 150,
            },
            {
                vel: 150,
                promoVel: 200,
            },
            {
                vel: 200,
                promoVel: 500,
            },
            {
                vel: 500,
                promoVel: 1000,
            },
            {
                vel: 1000,
            },
        ],
    },
    {
        category: 'residencial',
        prices: [
            {
                vel: 80,
                promoVel: 100,
            },
            {
                vel: 100,
                promoVel: 150,
            },
            {
                vel: 150,
                promoVel: 200,
            },
            {
                vel: 200,
                promoVel: 500,
            },
            {
                vel: 500,
                promoVel: 1000,
            },
            {
                vel: 1000,
            },
        ],
    },
    {
        category: 'izzinegocios',
        prices: [
            {
                vel: 80,
                promoVel: 100,
            },
            {
                vel: 100,
                promoVel: 150,
            },
            {
                vel: 150,
                promoVel: 200,
            },
            {
                vel: 200,
                promoVel: 500,
            },
            {
                vel: 500,
                promoVel: 1000,
            },
            {
                vel: 1000,
            },
        ],
    },
    {
        category: 'izzinegocios_3P',
        prices: [
            {
                vel: 80,
                promoVel: 100,
            },
            {
                vel: 100,
                promoVel: 150,
            },
            {
                vel: 150,
                promoVel: 200,
            },
            {
                vel: 200,
                promoVel: 500,
            },
            {
                vel: 500,
                promoVel: 1000,
            },
            {
                vel: 1000,
            },
        ],
    },
    {
        category: 'izzinegocios_3PM',
        prices: [
            {
                vel: 80,
                promoVel: 120,
            },
            {
                vel: 100,
                promoVel: 150,
            },
            {
                vel: 150,
                promoVel: 200,
            },
            {
                vel: 200,
                promoVel: 500,
            },
            {
                vel: 500,
                promoVel: 1000,
            },
            {
                vel: 1000,
            },
        ],
    },
    {
        category: 'izzinegocios_4P',
        prices: [
            {
                vel: 80,
                promoVel: 120,
            },
            {
                vel: 100,
                promoVel: 150,
            },
            {
                vel: 150,
                promoVel: 200,
            },
            {
                vel: 200,
                promoVel: 500,
            },
            {
                vel: 500,
                promoVel: 1000,
            },
            {
                vel: 1000,
            },
        ],
    },
    {
        category: 'movil',
        details: [
            {
                nombreCode: 'izzimovil512meses',
                extName: 'izzi_movil 5 12 meses',
                features: ['5 GB para navegar y compartir'],
            },
            {
                nombreCode: 'izzimovil812meses',
                extName: 'izzi movil 8 12 meses',
                features: ['8 GB para navegar y compartir'],
            },
            {
                nombreCode: 'izzimovil8',
                extName: 'izzi movil 8',
                features: ['8 GB para navegar y compartir'],
            },
            {
                nombreCode: 'izzimovil15',
                extName: 'izzi movil 15',
                features: ['15 GB para navegar y compartir'],
            },
            {
                nombreCode: 'izzimovilcompartetusdatos12meses',
                extName: 'izzi movil comparte tus datos 12 meses',
                features: ['datos ilimitados para navegar y compartir'],
            },
            {
                nombreCode: 'izzimovilcompartetusdatos',
                extName: 'izzi movil comparte tus datos',
                features: ['datos ilimitados para navegar y compartir'],
            },
            {
                nombreCode: 'planfamiliarprincipal',
                features: ['3 líneas con 8 GB cada una'],
            },
        ],
        sharedDetails: sharedMovilDetails,
    },
    {
        category: 'tv',
        details: [
            {
                nombreCode: 'izzitv_ottm',
                features: [
                    '<a href="#/" on:click|preventDefault={} data-custom-open="canales_izzitvhdplus" >200 canales</a> de TV',
                    'Android TV',
                    'Acceso a izzi go',
                    'Hasta 1 extensión de TV',
                    'Sky sports. Inclye LALIGA EA sports',
                    // 'ViX Premium 12 meses',
                ],
            },
            {
                nombreCode: 'izzitv_basico',
                features: [
                    '<a href="#/" on:click|preventDefault={} data-custom-open="canales_izzitvhdplus" >200 canales</a> de TV',
                    'Android TV',
                    'Acceso a izzi go',
                    'Hasta 1 extensión de TV',
                    'Sky sports. Inclye LALIGA EA sports',
                    // 'ViX Premium 12 meses',
                ],
            },
            {
                nombreCode: 'izzitv_light',
                features: [
                    '<span class="black-text fw-semibold underline" >75 canales</span> de TV',
                    'Android TV',
                    'Hasta 1 extensión de TV',
                    'ViX Premium 12 meses',
                ],
            },
            {
                nombreCode: 'izzitv_lightm',
                features: [
                    '<span class="black-text fw-semibold underline" >75 canales</span> de TV',
                    'Android TV',
                    'Hasta 1 extensión de TV',
                    'ViX Premium 12 meses',
                ],
            },
        ],
    },
    {
        category: 'offnet_sky',
        details: [
            {
                nombreCode: 'skyprepagolight',
                promotion:
                    'Pago único $1250 <sup>(1)</sup> y llévate 4 meses de servicio',
                features: [
                    'A partir del 5º mes paga $199<sup>/mes</sup>',
                    '45 canales (31 HD y 14 SD)',
                    'Vigencia 30 días',
                ],
            },
            {
                nombreCode: 'skyprepago',
                promotion:
                    'Pago único $1250 <sup>(1)</sup> y llévate 4 meses de servicio',
                features: [
                    'A partir del 5º mes paga $269<sup>/mes</sup>',
                    '83 canales (70 HD y 13 SD)',
                    'Vigencia 30 días',
                    'Todos los partidos de la Bundesliga y LALIGA EA SPORTS',
                ],
            },
            {
                nombreCode: 'skyprepagovix',
                promotion:
                    'Pago único $1250 <sup>(1)</sup> y llévate 4 meses de servicio',
                features: [
                    'A partir del 5º mes paga $299<sup>/mes</sup>',
                    '85 canales (72 HD y 13 SD)',
                    'Incluido ViX Premium <sup>2</sup>',
                    'Vigencia 30 días',
                    'Todos los partidos de la Bundesliga y LALIGA EA SPORTS',
                ],
            },
        ],
    },
];
